// Haki_lt.: Khai bĂ¡o layout Desktop Default [START]
import config from'../../combineConfig';var staticFalse=config.switch.isWidgetStatic?true:false;// STRPROP = C#CS#PRICEBOARD#CB : KhĂ¡ch hĂ ng>CÆ¡ sá»Ÿ>Báº£ng giĂ¡>CÆ¡ báº£n
export var C_CS_PRICEBOARD_CB={"id":"C#CS#PRICEBOARD#CB","grid":{"lg":[{"w":12,"h":2,"x":0,"y":10,"i":"PRICEBOARD","minW":8,"minH":4,"moved":false,"static":staticFalse}],"md":[{"w":16,"h":8,"x":0,"y":0,"i":"PRICEBOARD","minW":8,"minH":4,"moved":false,"static":staticFalse}],"sm":[{"w":10,"h":8,"x":0,"y":0,"i":"PRICEBOARD","minW":8,"minH":4,"moved":false,"static":staticFalse}]},"visibleSectionIds":[// "indexsList",
// "topIndexes",
"PRICEBOARD"// "derivativeBoard",
// "coveredWarrantBoard",
// "bondBoard",
// "etfBoard",
],"sourceLayoutId":"C#CS#PRICEBOARD#CB","mergeSections":{"PRICEBOARD":[// "derivativeBoard",
// "coveredWarrantBoard",
// "etfBoard",
// "bondBoard",
]},//Haki_lt.: Khai floatLayout dáº¡ng Popup
"floatLayout":[// {
//     "w": 12,
//     "h": 20,
//     "x": 0,
//     "y": 8,
//     "i": "FilterDetail",
//     "minW": 6,
//     "minH": 2,
//     "moved": false,
//     "static": staticFalse
// },
]};// STRPROP = C#CS#TRADE#CB : KhĂ¡ch hĂ ng>CÆ¡ sá»Ÿ>Äáº·t lá»‡nh>CÆ¡ báº£n
export var C_CS_TRADE_CB={"id":"C#CS#TRADE#CB","grid":{"sm":[{"w":27,"h":4,"x":0,"y":0,"i":"infoSymbol","minW":3.2,"minH":10,"moved":false,"static":staticFalse},{"w":7,"h":18,"x":27,"y":0,"i":"placeOrderNormal","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":8,"h":14,"x":0,"y":4,"i":"infoPortfolioFavorites","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":19,"h":14,"x":8,"y":4,"i":"priceChart","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":18,"i":"openPositions","minW":6,"minH":2,"moved":false,"static":staticFalse}]},"visibleSectionIds":['placeOrderNormal','infoPortfolioFavorites','priceChart','depthChart','matchedOrder','openPositions','orderActive','orderCopy','normalOrderBook','conditionOrderBook',// 'brokerOrderBook',
'infoSymbol'// mặc định last
],"sourceLayoutId":"C#CS#TRADE#CB","mergeSections":{"infoSymbol":[],"infoPortfolioFavorites":[],"placeOrderNormal":[],"priceChart":["depthChart","matchedOrder"],"openPositions":["orderActive",'orderCopy',"normalOrderBook","conditionOrderBook"// "brokerOrderBook",
]},"floatLayout":[]};export var B_CS_TRADE_TT={"id":"B#CS#TRADE#TT","grid":{"lg":[// {
//     "w": 27,
//     "h": 4,
//     "x": 0,
//     "y": 0,
//     "i": "infoSymbol",
//     "minW": 3.2,
//     "minH": 10,
//     "moved": false,
//     "static": staticFalse,
// },
// {
//     "w": 7,
//     "h": 18,
//     "x": 27,
//     "y": 0,
//     "i": "placeOrderNormal",
//     "minW": 3,
//     "minH": 4,
//     "moved": false,
//     "static": staticFalse
// },
// {
//     "w": 8,
//     "h": 14,
//     "x": 0,
//     "y": 4,
//     "i": "infoPortfolioFavorites",
//     "minW": 3,
//     "minH": 4,
//     "moved": false,
//     "static": staticFalse,
// },
// {
//     "w": 19,
//     "h": 14,
//     "x": 8,
//     "y": 4,
//     "i": "priceChart",
//     "minW": 6,
//     "minH": 2,
//     "moved": false,
//     "static": staticFalse,
// },
{"w":19,"h":14,"x":8,"y":4,"i":"putthroughtOrder","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":18,"i":"openPositions","minW":6,"minH":2,"moved":false,"static":staticFalse}],"md":[// {
//     "w": 27,
//     "h": 4,
//     "x": 0,
//     "y": 0,
//     "i": "infoSymbol",
//     "minW": 3.2,
//     "minH": 10,
//     "moved": false,
//     "static": staticFalse,
// },
// {
//     "w": 7,
//     "h": 18,
//     "x": 27,
//     "y": 0,
//     "i": "placeOrderNormal",
//     "minW": 3,
//     "minH": 4,
//     "moved": false,
//     "static": staticFalse,
// },
// {
//     "w": 8,
//     "h": 14,
//     "x": 0,
//     "y": 4,
//     "i": "infoPortfolioFavorites",
//     "minW": 3,
//     "minH": 4,
//     "moved": false,
//     "static": staticFalse
// },
// {
//     "w": 19,
//     "h": 14,
//     "x": 8,
//     "y": 4,
//     "i": "priceChart",
//     "minW": 6,
//     "minH": 2,
//     "moved": false,
//     "static": staticFalse
// },
{"w":19,"h":14,"x":8,"y":4,"i":"putthroughtOrder","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":18,"i":"openPositions","minW":6,"minH":2,"moved":false,"static":staticFalse}],"sm":[// {
//     "w": 27,
//     "h": 4,
//     "x": 0,
//     "y": 0,
//     "i": "infoSymbol",
//     "minW": 3.2,
//     "minH": 10,
//     "moved": false,
//     "static": staticFalse,
// },
// {
//     "w": 7,
//     "h": 18,
//     "x": 27,
//     "y": 0,
//     "i": "placeOrderNormal",
//     "minW": 3,
//     "minH": 4,
//     "moved": false,
//     "static": staticFalse,
// },
// {
//     "w": 8,
//     "h": 14,
//     "x": 0,
//     "y": 4,
//     "i": "infoPortfolioFavorites",
//     "minW": 3,
//     "minH": 4,
//     "moved": false,
//     "static": staticFalse
// },
// {
//     "w": 19,
//     "h": 14,
//     "x": 8,
//     "y": 4,
//     "i": "priceChart",
//     "minW": 6,
//     "minH": 2,
//     "moved": false,
//     "static": staticFalse
// },
{"w":19,"h":14,"x":8,"y":4,"i":"putthroughtOrder","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":18,"i":"openPositions","minW":6,"minH":2,"moved":false,"static":staticFalse}]},"visibleSectionIds":[// "PRICEBOARD",
// "ordersList",
// "placeOrder",
// "openPositions",
// "brokerOrders",
// "lookupOrders",
// "lookupOrdersNew"
// 'placeOrderNormal',
// 'infoPortfolioFavorites',
// 'priceChart',
'openPositions','putthroughtOrder'// 'infoSymbol', // mặc định last
],"sourceLayoutId":"B#CS#TRADE#TT","mergeSections":{// "PRICEBOARD": ["openPositions"],
// "ordersList": [
//     "brokerOrders",
//     // "openPositions",
//     "lookupOrders",
//     "lookupOrdersNew"
// ]
},"floatLayout":[]};export var C_CS_TRADE_CB_bk={"id":"C#CS#TRADE#CB","grid":{"lg":[{// "w": 8,
// "h": 4,
// "x": 0,
// "y": 10,
// "i": "PRICEBOARD",
// "minW": 8,
// "minH": 4,
// "moved": false,
// "static": staticFalse
"w":16,"h":10,"x":0,"y":0,"i":"PRICEBOARD","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":13.2,"h":16,"x":3.2,"y":10,"i":"ordersList","minW":6,"minH":2,"moved":false,"static":staticFalse}],"md":[{"w":16,"h":8,"x":0,"y":0,"i":"PRICEBOARD","minW":8,"minH":4,"moved":false,"static":staticFalse}],"sm":[{"w":10,"h":8,"x":0,"y":0,"i":"PRICEBOARD","minW":8,"minH":4,"moved":false,"static":staticFalse}]},"visibleSectionIds":[// "indexsList",
// "topIndexes",
"PRICEBOARD",// "derivativeBoard",
// "coveredWarrantBoard",
// "bondBoard",
// "etfBoard",
"ordersList"],"sourceLayoutId":"C#CS#TRADE#CB","mergeSections":{"PRICEBOARD":[// "derivativeBoard",
// "coveredWarrantBoard",
// "etfBoard",
// "bondBoard",
]},//Haki_lt.: Khai floatLayout dáº¡ng Popup
"floatLayout":[// {
//     "w": 12,
//     "h": 20,
//     "x": 0,
//     "y": 8,
//     "i": "FilterDetail",
//     "minW": 6,
//     "minH": 2,
//     "moved": false,
//     "static": staticFalse
// },
]};// STRPROP = C#CS#TRADE#NC : KhĂ¡ch hĂ ng>CÆ¡ sá»Ÿ>Äáº·t lá»‡nh>NĂ¢ng cao
export var C_CS_TRADE_NC={"id":"C#CS#TRADE#NC","grid":{"sm":[{"w":34,"h":3,"x":0,"y":0,"i":"infoSymbol","minW":3.2,"minH":10,"moved":false,"static":staticFalse},{"w":34,"h":14,"x":27,"y":3,"i":"infoPortfolioFavorites","minW":6,"minH":6,"moved":false,"static":staticFalse},{"w":34,"h":14,"x":0,"y":17,"i":"recentTrades","minW":7,"minH":10,"moved":false,"static":staticFalse},{"w":34,"h":11,"x":7,"y":3,"i":"priceChart","minW":10,"minH":10,"moved":false,"static":staticFalse},{"w":0,"h":0,"x":0,"y":14,"i":"placeOrderPro","minW":10,"minH":12,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":14,"i":"depthChart","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":10,"x":0,"y":26,"i":"openPositions","minW":10,"minH":14,"moved":false,"static":staticFalse}]},"visibleSectionIds":['infoPortfolioFavorites','recentTrades','priceChart','depthChart','openPositions','placeOrderPro','orderActive','normalOrderBook','conditionOrderBook','infoSymbol'// mặc định last
// dưới k dùng
// 'mixedOrderbook',
// 'orderMatched',
],"sourceLayoutId":"C#CS#TRADE#NC","mergeSections":{"infoPortfolioFavorites":[],"recentTrades":[],"priceChart":[],"depthChart":[],"placeOrderPro":[],"infoSymbol":[],"openPositions":["orderActive","normalOrderBook","conditionOrderBook"]},//Haki_lt.: Khai floatLayout dáº¡ng Popup
"floatLayout":[// {
//     "w": 12,
//     "h": 20,
//     "x": 0,
//     "y": 8,
//     "i": "FilterDetail",
//     "minW": 6,
//     "minH": 2,
//     "moved": false,
//     "static": staticFalse
// },
]};// STRPROP = B#CS#PRICEBOARD#CB : MĂ´i giá»›i>CÆ¡ sá»Ÿ>Báº£ng giĂ¡>CÆ¡ báº£n
export var B_CS_PRICEBOARD_CB={};// STRPROP = B#CS#TRADE#CB : MĂ´i giá»›i>CÆ¡ sá»Ÿ>Äáº·t lá»‡nh>CÆ¡ báº£n
export var B_CS_TRADE_CB={"id":"B#CS#TRADE#CB","grid":{"sm":[{"w":27,"h":4,"x":0,"y":0,"i":"infoSymbol","minW":3.2,"minH":10,"moved":false,"static":staticFalse},{"w":7,"h":18,"x":27,"y":0,"i":"placeOrderNormal","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":8,"h":14,"x":0,"y":4,"i":"infoPortfolioFavorites","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":19,"h":14,"x":8,"y":4,"i":"priceChart","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":18,"i":"openPositions","minW":6,"minH":2,"moved":false,"static":staticFalse}]},"visibleSectionIds":['placeOrderNormal','infoPortfolioFavorites','priceChart','depthChart','matchedOrder','openPositions','orderActive','normalOrderBook','conditionOrderBook','brokerOrderBook','infoSymbol'// mặc định last
],"sourceLayoutId":"B#CS#TRADE#CB","mergeSections":{"infoSymbol":[],"infoPortfolioFavorites":[],"placeOrderNormal":[],"priceChart":["depthChart","matchedOrder"],"openPositions":["orderActive","normalOrderBook",'conditionOrderBook',"brokerOrderBook","draftOrderBook"]},"floatLayout":[]};// STRPROP = B#CS#TRADE#NC : MĂ´i giá»›i>CÆ¡ sá»Ÿ>Äáº·t lá»‡nh>NĂ¢ng cao
export var B_CS_TRADE_NC={"id":"B#CS#TRADE#NC","grid":{"sm":[{"w":34,"h":3,"x":0,"y":0,"i":"infoSymbol","minW":3.2,"minH":10,"moved":false,"static":staticFalse},{"w":34,"h":14,"x":27,"y":3,"i":"infoPortfolioFavorites","minW":6,"minH":6,"moved":false,"static":staticFalse},{"w":34,"h":14,"x":0,"y":17,"i":"recentTrades","minW":7,"minH":10,"moved":false,"static":staticFalse},{"w":34,"h":11,"x":7,"y":3,"i":"priceChart","minW":10,"minH":10,"moved":false,"static":staticFalse},{"w":0,"h":0,"x":0,"y":14,"i":"placeOrderPro","minW":10,"minH":12,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":14,"i":"depthChart","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":10,"x":0,"y":26,"i":"openPositions","minW":10,"minH":14,"moved":false,"static":staticFalse}]},"visibleSectionIds":['infoPortfolioFavorites','recentTrades','priceChart','depthChart','openPositions','placeOrderPro','orderActive','normalOrderBook','conditionOrderBook',"brokerOrderBook",'infoSymbol'// mặc định last
// dưới k dùng
// 'mixedOrderbook',
// 'orderMatched',
],"sourceLayoutId":"B#CS#TRADE#NC","mergeSections":{"infoPortfolioFavorites":[],"recentTrades":[],"priceChart":[],"depthChart":[],"placeOrderPro":[],"infoSymbol":[],"openPositions":["orderActive","normalOrderBook",'conditionOrderBook',"brokerOrderBook","draftOrderBook"]},//Haki_lt.: Khai floatLayout dáº¡ng Popup
"floatLayout":[// {
//     "w": 12,
//     "h": 20,
//     "x": 0,
//     "y": 8,
//     "i": "FilterDetail",
//     "minW": 6,
//     "minH": 2,
//     "moved": false,
//     "static": staticFalse
// },
]};export var C_CS_MARKET_WATCH={"id":"C#CS#MARKET_WATCH","grid":{"lg":[{"w":11,"h":12,"x":0,"y":0,"i":"marketBreadth","minW":6,"minH":2,"moved":false,"static":true},{"w":22,"h":12,"x":0,"y":12,"i":"liquidityChart","minW":6,"minH":2,"moved":false,"static":true},{"w":12,"h":24,"x":22,"y":0,"i":"newsMarket","minW":6,"minH":2,"moved":false,"static":true}],"md":[{"w":11,"h":12,"x":0,"y":0,"i":"marketBreadth","minW":6,"minH":2,"moved":false,"static":true},{"w":22,"h":12,"x":0,"y":12,"i":"liquidityChart","minW":6,"minH":2,"moved":false,"static":true},{"w":12,"h":24,"x":22,"y":0,"i":"newsMarket","minW":6,"minH":2,"moved":false,"static":true}],"sm":[{"w":11,"h":12,"x":0,"y":0,"i":"marketBreadth","minW":6,"minH":2,"moved":false,"static":true},{"w":22,"h":12,"x":0,"y":12,"i":"liquidityChart","minW":6,"minH":2,"moved":false,"static":true},{"w":12,"h":24,"x":22,"y":0,"i":"newsMarket","minW":6,"minH":2,"moved":false,"static":true}]},"visibleSectionIds":['marketBreadth','topStockUp','topStockDown','mutationLiquidity','recommendedList','liquidityChart','heatMap','foreignBlockChart','newsMarket','analysisMarket'],"sourceLayoutId":"MARKET_WATCH","mergeSections":{"marketBreadth":["mutationLiquidity","topStockUp","topStockDown"],"newsMarket":["analysisMarket","recommendedList"],"liquidityChart":["heatMap","foreignBlockChart"]},"floatLayout":[]};export var B_CS_MARKET_WATCH={"id":"B#CS#MARKET_WATCH","grid":{"lg":[{"w":11,"h":12,"x":0,"y":0,"i":"marketBreadth","minW":6,"minH":2,"moved":false,"static":true},{"w":22,"h":12,"x":0,"y":12,"i":"liquidityChart","minW":6,"minH":2,"moved":false,"static":true},{"w":12,"h":24,"x":22,"y":0,"i":"newsMarket","minW":6,"minH":2,"moved":false,"static":true}],"md":[{"w":11,"h":12,"x":0,"y":0,"i":"marketBreadth","minW":6,"minH":2,"moved":false,"static":true},{"w":22,"h":12,"x":0,"y":12,"i":"liquidityChart","minW":6,"minH":2,"moved":false,"static":true},{"w":12,"h":24,"x":22,"y":0,"i":"newsMarket","minW":6,"minH":2,"moved":false,"static":true}],"sm":[{"w":11,"h":12,"x":0,"y":0,"i":"marketBreadth","minW":6,"minH":2,"moved":false,"static":true},{"w":22,"h":12,"x":0,"y":12,"i":"liquidityChart","minW":6,"minH":2,"moved":false,"static":true},{"w":12,"h":24,"x":22,"y":0,"i":"newsMarket","minW":6,"minH":2,"moved":false,"static":true}]},"visibleSectionIds":['marketBreadth','topStockUp','topStockDown','mutationLiquidity','recommendedList','liquidityChart','heatMap','foreignBlockChart','newsMarket','analysisMarket'],"sourceLayoutId":"MARKET_WATCH","mergeSections":{"marketBreadth":["mutationLiquidity","topStockUp","topStockDown"],"newsMarket":["analysisMarket","recommendedList"],"liquidityChart":["heatMap","foreignBlockChart"]},"floatLayout":[]};export var C_ASSET_TOTAL={"id":"C#CS#ASSET_TOTAL","grid":{"sm":[{"w":34,"h":8,"x":0,"y":0,"i":"fcomAssetMini","minW":5,"minH":3,"moved":false,"static":staticFalse},// {
//     "w": 34,
//     "h": 5,
//     "x": 0,
//     "y": 3,
//     "i": "fcomAssetMiniChart",
//     "minW": 5,
//     "minH": 3,
//     "moved": false,
//     "static": staticFalse,
// },
{"w":17,"h":10,"x":0,"y":8,"i":"fcomAllocatedCateChart","minW":5,"minH":3,"moved":false,"static":staticFalse},{"w":17,"h":10,"x":17,"y":8,"i":"fcomInvestmentEffiencyChart","minW":5,"minH":3,"moved":false,"static":staticFalse},{"w":34,"h":10,"x":0,"y":18,"i":"openPositions","minW":5,"minH":3,"moved":false,"static":staticFalse},{"w":17,"h":10,"x":0,"y":28,"i":"closeposition","minW":5,"minH":3,"moved":false,"static":staticFalse},{"w":17,"h":10,"x":17,"y":28,"i":"fcomPnlHistChart","minW":5,"minH":3,"moved":false,"static":staticFalse}]},"visibleSectionIds":['fcomAssetMini',// 'fcomAssetMiniChart',
'fcomAllocatedCateChart','fcomInvestmentEffiencyChart','openPositions','closeposition','fcomPnlHistChart'],"sourceLayoutId":"C#CS#ASSET_TOTAL","mergeSections":{'fcomAssetMini':[],// 'fcomAssetMiniChart': [],
'fcomAllocatedCateChart':[],'fcomInvestmentEffiencyChart':[],'openPositions':[],'closeposition':[],'fcomPnlHistChart':[]},"floatLayout":[]};export var B_ASSET_TOTAL={"id":"B#CS#ASSET_TOTAL","grid":{"sm":[{"w":34,"h":8,"x":0,"y":0,"i":"fcomAssetMini","minW":5,"minH":3,"moved":false,"static":staticFalse},// {
//     "w": 34,
//     "h": 5,
//     "x": 0,
//     "y": 3,
//     "i": "fcomAssetMiniChart",
//     "minW": 5,
//     "minH": 3,
//     "moved": false,
//     "static": staticFalse,
// },
{"w":17,"h":10,"x":0,"y":8,"i":"fcomAllocatedCateChart","minW":5,"minH":3,"moved":false,"static":staticFalse},{"w":17,"h":10,"x":17,"y":8,"i":"fcomInvestmentEffiencyChart","minW":5,"minH":3,"moved":false,"static":staticFalse},{"w":34,"h":10,"x":0,"y":18,"i":"openPositions","minW":5,"minH":3,"moved":false,"static":staticFalse},{"w":17,"h":10,"x":0,"y":28,"i":"closeposition","minW":5,"minH":3,"moved":false,"static":staticFalse},{"w":17,"h":10,"x":17,"y":28,"i":"fcomPnlHistChart","minW":5,"minH":3,"moved":false,"static":staticFalse}]},"visibleSectionIds":['fcomAssetMini',// 'fcomAssetMiniChart',
'fcomAllocatedCateChart','fcomInvestmentEffiencyChart','openPositions','closeposition','fcomPnlHistChart'],"sourceLayoutId":"B#CS#ASSET_TOTAL","mergeSections":{'fcomAssetMini':[],// 'fcomAssetMiniChart': [],
'fcomAllocatedCateChart':[],'fcomInvestmentEffiencyChart':[],'openPositions':[],'closeposition':[],'fcomPnlHistChart':[]},"floatLayout":[]};// Config mặc định dành cho tất cả các widget.: Sử dụng trong trường hợp unmerge hoặc thêm mới
export var DefaultSession={"lg":[{"w":25,"h":4,"x":0,"y":0,"i":"infoSymbol","minW":3.2,"minH":10,"moved":false,"static":staticFalse},{"w":9,"h":18,"x":25,"y":0,"i":"placeOrderNormal","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":8,"h":14,"x":0,"y":4,"i":"infoPortfolioFavorites","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":17,"h":14,"x":8,"y":4,"i":"priceChart","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":18,"i":"openPositions","minW":6,"minH":2,"moved":false,"static":staticFalse}],"md":[{"w":25,"h":4,"x":0,"y":0,"i":"infoSymbol","minW":3.2,"minH":10,"moved":false,"static":staticFalse},{"w":9,"h":18,"x":25,"y":0,"i":"placeOrderNormal","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":8,"h":14,"x":0,"y":4,"i":"infoPortfolioFavorites","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":17,"h":14,"x":8,"y":4,"i":"priceChart","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":18,"i":"openPositions","minW":6,"minH":2,"moved":false,"static":staticFalse}],"sm":[{"w":25,"h":4,"x":0,"y":0,"i":"infoSymbol","minW":3.2,"minH":10,"moved":false,"static":staticFalse},{"w":9,"h":18,"x":25,"y":0,"i":"placeOrderNormal","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":8,"h":14,"x":0,"y":4,"i":"infoPortfolioFavorites","minW":3,"minH":4,"moved":false,"static":staticFalse},{"w":17,"h":14,"x":8,"y":4,"i":"priceChart","minW":6,"minH":2,"moved":false,"static":staticFalse},{"w":34,"h":12,"x":0,"y":18,"i":"openPositions","minW":6,"minH":2,"moved":false,"static":staticFalse}]};